export default "__VITE_ASSET__c5c8e15d__"